import { DialogType } from '../enumerators/messages.enum';
import { DialogOption } from './dialog-option.model';

export class Dialog {
    static confirm(arg0: { title: string; message: string; accept: () => void; }): any {
      throw new Error('Method not implemented.');
    }
    public type: DialogType = DialogType.Normal;
    public title: string = "";
    public message: string = "";
    public size: number = 40;
    public options: Array<DialogOption> = [];

    constructor(init?: Partial<Dialog>) {
        Object.assign(this, init);
    }
}
